// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./img/arrow-down.svg", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./img/search.svg", import.meta.url);
// Module
var code = `<div class="dropdown-textbox">
  <div class="dropdown-textbox-content">
    <div class="dropdown-textbox-inner">
      <div class="dropdown-textbox-title">
      </div>
      <img src="${___HTML_LOADER_IMPORT_0___}" alt="arrow">
    </div>
  </div>
  <div class="dropdown-main-container">
    <div class="dropdown-wrapper">
      <div class="searchable-dropdown-container">
        <!-- Search Section -->
        <div class="search-section">
          <div class="search-input-container">
            <div class="search-input-wrapper">
              <div class="search-icon-container">
                <div class="search-icon">
                  <img src="${___HTML_LOADER_IMPORT_1___}" alt="search">
                </div>
                <input type="text" class="search-input" placeholder="Search" id="search-input" />
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown-content">
          <!-- Selected Label -->
          <div class="selected-label"> Selected </div>

          <!-- Items Container -->
          <div class="dropdown-items-container" id="dropdown-items">
            <!-- Items will be populated by JavaScript -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;